import { createSlice } from "@reduxjs/toolkit";

class StorageAdapter {
    static getStateFromStorage() {

        let sessionToken = localStorage.getItem('sessionToken');
        let userString = localStorage.getItem('user');
        let user = null;
        try {
            user = JSON.parse(userString);
        } catch (e) {
            user = null;
        }
        return {
            mqttCredentials: null,
            user,
            sessionToken,
            isInitialized: false,
        };
    }
}


const AuthSlice = createSlice({
    initialState: {},
    name: 'auth',
    reducers: {
        load: (state, action) => {
            return {
                ...StorageAdapter.getStateFromStorage(),
                isInitialized: true,
            };
        },
        set: (state, action) => {
            localStorage.setItem('sessionToken', action.payload.sessionToken);
            localStorage.setItem('user', JSON.stringify(action.payload.user));
            return {
                ...state,
                user: action.payload.user,
                sessionToken: action.payload.sessionToken,
                isInitialized: true,
            };
        },
    },

});


export { AuthSlice };